import { BlockWrapperInterface, BlockWrapperType } from '@nx-frontend/shared/types/portal-block';
import { PortalBgType, PortalTextType } from '@nx-frontend/shared/types/portal-colors';

export const defaultBlockWrapper: BlockWrapperInterface = {
  type: 'blank',
  showTitle: true,
  className: ['p-4'],
  theme: {
    bg: { main: PortalBgType.SURFACE },
    text: { main: PortalTextType.SURFACE },
  },
};

export const getWrapperProps = (wrapper: BlockWrapperType | BlockWrapperInterface): BlockWrapperInterface => {
  if (typeof wrapper === 'string') {
    return {
      ...defaultBlockWrapper,
      type: wrapper,
      ...(['none', 'bare'].includes(wrapper) ? { showTitle: false } : null),
    };
  }
  return { ...defaultBlockWrapper, ...wrapper };
};
